
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maledaily",
      function () {
        return require("private-next-pages/maledaily/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maledaily"])
      });
    }
  